const en = {
  ACTIVITY: 'Activity',
  ADD_INTERVAL: 'Add Interval',
  AI_ASSISTANT_TOOLTIP: 'Slow assistant',
  AI_ASSISTANT: 'Slow assistant',
  AI_ASSISTANT_PLACEHOLDER: 'Ask assistant for anything related to your time tracked',
  AI_ASSISTANT_WELCOME: 'Hello! I\'m slower than fast assistant but I remember context of our conversation',
  AI_ASSISTANT_ERROR: 'Error occurred. Try again later or mail developer at support@timetrack.io',
  AI_COMPLETION_TOOLTIP: 'aTimeLogger assistant',
  AI_COMPLETION_ASSISTANT: 'aTimeLogger assistant',
  AI_COMPLETION_PLACEHOLDER: 'Write your question',
  AI_COMPLETION_WELCOME: 'Hello! I\'m aTimeLogger assistant. You can ask me questions about time logged and some insights',
  AI_COMPLETION_ERROR: 'Error occurred. Try again later or mail developer at support@timetrack.io',

  CREATE_ACTIVITY: 'Create Activity',
  CREATE_FILTER_CONFIGURATION: 'Save Filter',
  CONFIRM_FILTER_DELETE: 'Are you sure you want to delete the filter?',
  RECORDS: 'Records',
  RESTORE: 'Restore',
  CHANGE_PASSWORD: 'Change password',
  RUNNING: 'Running',
  SAVE: 'Save',
  SAVE_FILTER_CONFIGURATION: 'Save Filter',
  SELECT_TIMEZONE: 'Select Timezone',
  SELECT_TYPES: 'Select Types',
  SELECT_ACTIVITY: 'Select Activity',
  SELECT_TAGS: 'Select Tags',
  SELECT_FILTER: 'Select Filter',
  SETTINGS: 'Settings',
  START_ACTIVITY: 'Start',
  STATUS: 'Status',
  STOPPED: 'Stopped',
  STOP: 'Stop running activity',
  START: 'Start',
  SIGN_IN: 'Sign In',
  SUMMARY: 'Summary',
  TIMEZONE: 'Timezone',
  TOTAL: 'Total',
  GROUPED: 'Trends',
  EDIT: 'Edit',
  EDIT_USER: 'Edit User',
  EDIT_ACTIVITY: 'Edit Activity',
  ENTER_USERNAME: 'Enter your username',
  ENTER_PASSWORD: 'Enter your password',
  FILTER_NAME_PLACEHOLDER: 'Enter Filter Name',
  PASSWORD: 'Password',
  REPEAT_PASSWORD: 'Repeat password',
  PAUSED: 'Paused',
  PAUSE: 'Pause running activity',
  FINISH: 'Finish',
  FORGOT_PASSWORD: 'Forgot Password',
  HISTORY: 'History',
  INTERVALS: 'Intervals',
  COMMENT: 'Comment',
  DURATION: 'Duration',
  DOWNLOAD_HISTORY: 'Export',
  TAGS: 'Tags',
  TODAY: 'Today',
  THIS_WEEK: 'This Week',
  THIS_MONTH: 'This Month',
  TYPE_ID: 'Activity Type',
  TYPES: 'Types',
  YES: 'Yes',
  YESTERDAY: 'Yesterday',
  NO: 'No',
  NONE: 'Do nothing (2 or more activities will run)',
  DELETE: 'Delete',
  DELETE_INTERVAL: 'Delete the interval',
  DELETE_INTERVAL_CONFIRM: 'Are you sure you want to delete this interval?',
  USER: 'User',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  LAST_WEEK: 'Last Week',
  LAST_MONTH: 'Last Month',
  LOAD_MORE: 'More..',
  USER_NAME: 'E-Mail',
  FULL_PATH: 'Display full path to activity type',
  LANGUAGE: 'Language',
  SELECT_LANGUAGE: 'Select Language',
  ON_START_ACTION: 'Action on start',
}

export default en
